import React from "react";

import { localizer } from "../../Translator";

import { Grid, Typography } from "@material-ui/core";
import { Backdrop, CircularProgress } from "@material-ui/core"

import { BoxSelector } from "../common/BoxSelector";

import OutboxCli from "../../sdk/OutboxCli";

export class MultiOcrImageViewer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Shipment page list containing the pages of all the documents
      documentpages: [],

      // Number document page requested to be displayed
      pagenumber: 1,

      // Image content represents in base64 format
      base64: null,

      coordinatedLeft: 45,
      coordinatedTop: 20,
      coordinatedWidth: 42,
      coordinatedHeight: 7,

      // Width and height in pixels given to the viewer. The displayed background image will be resized to this width and heigth.
      viewerWidth: 1,
      viewerHeight: 1,

      //error message to display in case of api calls fail
      errormessage: null,

      isLoading: false
    }
  }
  
  componentDidMount() {
    if (this.props) {

      let documentpages = []
      for (let i = 0; i < this.props.documentpages.length; i++) {
        const pages = this.props.documentpages[i];
        for (let j = pages.pageFirst; j <= pages.pageLast; j++) {
          const singlepage = { documentid: pages.draftId, pagenumber: j }
          documentpages.push(singlepage)
        }
      }
      
      this.setState({
        documentpages: documentpages,
        pagenumber: this.props.pagenumber,
        viewerWidth: this.props.viewerWidth,
        viewerHeight: this.props.viewerHeight,
        coordinatedLeft: this.props.coordinatedLeft,
        coordinatedTop: this.props.coordinatedTop,
        coordinatedWidth: this.props.coordinatedWidth,
        coordinatedHeight: this.props.coordinatedHeight
      },
        () => {
          this.getPage()
        })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.documentpages === prevProps.documentpages &&
      this.props.pagenumber === prevProps.pagenumber &&
      this.props.viewerWidth === prevProps.viewerWidth &&
      this.props.viewerHeight === prevProps.viewerHeight &&
      this.props.coordinatedLeft === prevProps.coordinatedLeft &&
      this.props.coordinatedTop === prevProps.coordinatedTop &&
      this.props.coordinatedWidth === prevProps.coordinatedWidth &&
      this.props.coordinatedHeight === prevProps.coordinatedHeight) return

    let documentpages = []
    for (let i = 0; i < this.props.documentpages.length; i++) {
      const pages = this.props.documentpages[i];
      for (let j = pages.pageFirst; j <= pages.pageLast; j++) {
        const singlepage = { documentid: pages.draftId, pagenumber: j }
        documentpages.push(singlepage)
      }
    }
      
    this.setState({
      documentpages: documentpages,
      pagenumber: this.props.pagenumber,
      viewerWidth: this.props.viewerWidth,
      viewerHeight: this.props.viewerHeight,
      coordinatedLeft: this.props.coordinatedLeft,
      coordinatedTop: this.props.coordinatedTop,
      coordinatedWidth: this.props.coordinatedWidth,
      coordinatedHeight: this.props.coordinatedHeight
    }, () => { if(this.props.documentpages !== prevProps.documentpages || this.props.pagenumber !== prevProps.pagenumber) this.getPage() })
  }

  /**
   * Returns base64 of a page and draft requested
   */
  getPage = () => {

    this.setState({ isLoading: true })

    if (this.state.documentpages.length < this.state.pagenumber) return

    let page = this.state.documentpages[this.state.pagenumber - 1]

    OutboxCli.GetDraftPageImage(page.documentid, page.pagenumber, 0, 0, 100, 100).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ errormessage: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ base64: response, errormessage: null })
      }

      this.setState({ isLoading: false })
    })
  }

  /**
   * Loading the previous page that it has to be displayed. If it is in the first page, it doesnt do anything
   */
  previousPage = () => {
    if (this.state.pagenumber > 1) {
      let pagenumber = this.state.pagenumber
      this.setState({ pagenumber: --pagenumber },
        () => {
          this.getPage()
        }
      )
    }
  }

  /**
   * Loading the next page that it has to be displayed. If there are no more pages, it doesnt do anything
   */
  nextPage = () => {
    if (this.state.pagenumber < this.state.documentpages.length) {
      let pagenumber = this.state.pagenumber
      this.setState({ pagenumber: ++pagenumber },
        () => {
          this.getPage()
        }
      )
    }
  }

  /* Sets coordinates selected when user drag an address in the document */
  handleBoxChange = (l, t, w, h) => {
    
    if (!w || !h || !l || !t) return 
    if (w < 0 || h < 0 || l < 0 || t < 0) return 
    if (w === 0 || h === 0 || (l === t)) return     
  
    this.setState({
      coordinatedLeft: l,
      coordinatedTop: t,
      coordinatedWidth: w,
      coordinatedHeight: h,
    }, () => {
      this.props.doRecalculateProposals(this.state.coordinatedLeft, this.state.coordinatedTop, this.state.coordinatedWidth, this.state.coordinatedHeight)
      if (this.state.documentpages.length < this.state.pagenumber) return

      let page = this.state.documentpages[this.state.pagenumber - 1]
      
      OutboxCli.DetectAddressesInPage(page.documentid,
        page.pagenumber,
        this.state.coordinatedLeft,
        this.state.coordinatedTop,
        this.state.coordinatedWidth,
        this.state.coordinatedHeight
      ).then(response => {
        if (response !== null && response.toString().startsWith("[ERR")) {
          this.setState({ errormessage: response.substring(response.indexOf(' ')) })
        } else {
          if (response.length > 0) {
            this.props.doSetAddressByOcrProposal(response)
          } else {
            this.setState({ errormessage: localizer.AddressNotDetected })
          }
        }
      })
    })
  }

  render() {
    return (
      <React.Fragment>

        <Grid container direction="row" spacing={2} alignItems="center" justify="center">

          <Grid container item md={12} justify="center">
            {this.state.base64 &&
              <BoxSelector
                imageSrc={"data:image/png;base64, " + this.state.base64}
                canvasWidth={this.state.viewerWidth}
                canvasHeight={this.state.viewerHeight}
                left={this.state.coordinatedLeft}
                top={this.state.coordinatedTop}
                width={this.state.coordinatedWidth}
                height={this.state.coordinatedHeight}
                onChanged={(l, t, w, h) => this.handleBoxChange(l, t, w, h)}
              />
            }
          </Grid>
          <Grid container item md={12} justify="center">
            {/* <i className="fa-solid fa-caret-left font-size-25 cursor-pointer" onClick={this.previousPage}></i> */}
            <Typography className="typography-generic"> {localizer.Page + " " + this.state.pagenumber + " " + localizer.Of + " " + this.state.documentpages.length} </Typography>
            {/* <i className="fa-solid fa-caret-right font-size-30 cursor-pointer" onClick={this.nextPage}></i> */}
          </Grid>

        </Grid>

        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Utilities/MultiOcrImageViewer.js